import dynamic from 'next/dynamic';

import AppContext from 'context/app';
import CountryContext from 'context/country';

import { ExperimentProviderType } from './types';

export default dynamic<ExperimentProviderType>(() =>
  import('./experiment').then(mod => mod.ExperimentProvider),
);

export { AppContext, CountryContext };
